import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const AssetPublishIndicator = ({ hasChangesAfterLastPublish, classes }) => {
    if (!hasChangesAfterLastPublish) {
        return null;
    }

    return (
        <Tooltip title="Has unpublished changed">
            <span className={classes.wrapper}>
                <span className={classes.indicator}>
                    <span className={classes.dot} />
                    <span className={classes.pulseDot} />
                </span>
            </span>
        </Tooltip>
    );
};

AssetPublishIndicator.propTypes = {
    hasChangesAfterLastPublish: PropTypes.bool.isRequired,
};

const style = ({ spacing, palette, publishIndicator }) => ({
    '@keyframes pulse': {
        '0%': {
            transform: 'scale(0)',
            opacity: 0.0,
        },
        '25%': {
            transform: 'scale(0)',
            opacity: 0.0,
        },
        '50%': {
            transform: 'scale(0.1)',
            opacity: 0.1,
        },
        '75%': {
            transform: 'scale(0.5)',
            opacity: 0.5,
        },
        '100%': {
            transform: 'scale(1)',
            opacity: 0.0,
        },
    },
    wrapper: {
        width: 11,
        height: 11,
        marginTop: 4,
        marginLeft: 8,
    },
    indicator: {
        position: 'relative',
    },
    pulseDot: {
        border: {
            width: spacing.unit,
            style: 'solid',
            color: palette.primary.main,
        },
        background: 'transparent',
        height: spacing.unit,
        width: spacing.unit,
        opacity: 0,
        position: 'absolute',
        left: -spacing.unit,
        top: -spacing.unit,
        borderRadius: '50%',
        animationName: 'pulse',
        animationDuration: publishIndicator.animationDuration,
        animationTimingFunction: 'ease-out',
        animationIterationCount: 'infinite',
    },
    dot: {
        backgroundColor: palette.primary.main,
        position: 'absolute',
        width: spacing.unit,
        height: spacing.unit,
        borderRadius: '50%',
    },
});

export default injectSheet(style)(AssetPublishIndicator);



// WEBPACK FOOTER //
// ./src/components/assets/AssetPublishIndicator.js